// extracted by mini-css-extract-plugin
module.exports = {"bars":"scale_bars_1tttI1o"};